export default "__VITE_ASSET__DTL6g1$o__"